import ProForm, { ProFormText, ProFormSelect, ProFormDatePicker } from '@ant-design/pro-form'
import { formatSelectOptions, debounce } from 'utils'
import { useRef } from 'react'
import './Search.scss'
import { t } from 'i18next'
import { Button } from 'antd'

export const Search = props => {
    const { formStructure, getUserListPaginatedData } = props
    const formRef = useRef()

    const templateJSX = item => {
        switch (item.type) {
            case 'datePicker': // 日期选择器
                return <ProFormDatePicker name={item.name} label={item.label} key={item.name} width='md' />
            case 'text': // 文本输入
                return (
                    <ProFormText
                        name={item.name}
                        label={item.label}
                        key={item.name}
                        width='sm'
                        fieldProps={{
                            onKeyDown: debounce(e => {
                                if (e.key === 'Enter') {
                                    const values = formRef.current.getFieldsValue() // 拿到输入内容
                                    getUserListPaginatedData({...values, pageNum: 1, pageSize: 5}) // 提交搜索，更新分页， 参数 1 为默认分页第一页， 参数 2 为 onFinish 收集的表单项数据
                                }
                            }),
                            allowClear: false,
                        }}
                    />
                )
            case 'select': // 下拉选择框
                return (
                    <ProFormSelect
                        name={item.name}
                        label={item.label}
                        key={item.name}
                        request={async () => formatSelectOptions(item.data)}
                        width='lg'
                        fieldProps={{
                            allowClear: false,
                        }}
                    />
                )
            default:
                return <></> // 默认不产生元素
        }
    }

    return (
        <ProForm
            className='search'
            onFinish={debounce(values => getUserListPaginatedData({...values, pageNum: 1, pageSize: 5}))}
            formRef={formRef} // 事件中手动提交
            submitter={{
                render: (props, doms) => [
                    <Button
                        type='button'
                        key='rest'
                        onClick={() => {
                            props.form?.resetFields()
                            const values = props.form?.getFieldsValue() // 拿到输入内容
                            getUserListPaginatedData({...values, pageNum: 1, pageSize: 5}) // 提交搜索，更新分页， 参数 1 为默认分页第一页， 参数 2 为 onFinish 收集的表单项数据
                        }}
                    >
                        {t('common.reset')}
                    </Button>,
                    <Button
                        type='primary'
                        key='submit'
                        onClick={() => {
                            const values = props.form?.getFieldsValue() // 拿到输入内容
                            getUserListPaginatedData({...values, pageNum: 1, pageSize: 5}) // 提交搜索，更新分页， 参数 1 为默认分页第一页， 参数 2 为 onFinish 收集的表单项数据
                        }}
                    >
                        {t('common.search')}
                    </Button>,
                ],
            }} // 定制提交按钮
        >
            <div className='searchItem'>{formStructure?.map(item => templateJSX(item))}</div>
        </ProForm>
    )
}
